module.exports = __webpack_public_path__ + "static/media/nz.ac39ac00.png";